import React from 'react'

interface DormantIconProps {
  size?: number
  className?: string
}

export const DormantIcon: React.FC<DormantIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M2.67 0.66H13.66" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.66 6.66V8.66H4.67V6.66" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.16 3.66H2.17C1.34 3.66 0.67 4.34 0.67 5.16V13.16C0.67 13.99 1.34 14.66 2.17 14.66H14.16C14.99 14.66 15.66 13.99 15.66 13.16V5.16C15.66 4.34 14.99 3.66 14.16 3.66Z" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

/**
 * Filled variant of DormantIcon — neutral stone fill + `currentColor` stroke.
 * The stroke inherits the wrapper's `color` (e.g. `--base-muted-foreground`
 * on the Clarify "Ruhen lassen" button), while the fill stays constant.
 */
export const DormantFilledIcon: React.FC<DormantIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M14.16 3.67H2.17C1.34 3.67 0.67 4.34 0.67 5.17V13.16C0.67 13.99 1.34 14.66 2.17 14.66H14.16C14.99 14.66 15.66 13.99 15.66 13.16V5.17C15.66 4.34 14.99 3.67 14.16 3.67Z" fill="var(--colors-stone-150, #EEEDEC)" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.67 0.67H13.66" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.66 6.67V8.67H4.67V6.67" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

/**
 * Tab-open / active variant of DormantIcon — violet fill + stroke to mirror
 * the active sidebar entry. Uses design tokens (`--space-100/--space-700`)
 * so the icon adapts to the active theme.
 */
export const DormantOpenIcon: React.FC<DormantIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M14.16 3.66H2.17C1.34 3.66 0.67 4.34 0.67 5.16V13.16C0.67 13.99 1.34 14.66 2.17 14.66H14.16C14.99 14.66 15.66 13.99 15.66 13.16V5.16C15.66 4.34 14.99 3.66 14.16 3.66Z" fill="var(--space-100, #EDE9FE)" stroke="var(--space-700, #6D28D9)" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.67 0.66H13.66" stroke="var(--space-700, #6D28D9)" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.66 6.66V8.66H4.67V6.66" stroke="var(--space-700, #6D28D9)" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
